import React, { useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import packageStyle from "../../../DailyBooking.module.css";
import { BookingFlowDataContext } from "../../../../context/BookingFlowDataContextProvider";
import { ApplicationContext } from "../../../../context/ApplicationContextProvider";
import { MiniCheck } from "../../../../Components/AllImportFiles/ImportSvg";

const DailyDate = () => {
  const {
    setSendingDailyBookingDataOneWay,
    setTrackPickUpDateTimeArrOneWay,
    trackPickUpDateTimeArrOneWay,
  } = useContext(BookingFlowDataContext);
  const {
    selectedDate,
    PackageDayDate,
    mappedDatesOneWay,
    setMappedDatesOneWay,
    dailyPickupTime,
  } = useContext(ApplicationContext);

  const handleDailyTripDate = (elem) => {
    const date = elem[2];

    if (mappedDatesOneWay.has(date)) {
      // If the date is already selected, unselect it
      const newMappedDates = new Set(mappedDatesOneWay);
      newMappedDates.delete(date);
      setMappedDatesOneWay(newMappedDates);
    } else {
      // If the date is not selected, select it
      const newMappedDates = new Set(mappedDatesOneWay);
      newMappedDates.add(date);
      setMappedDatesOneWay(newMappedDates);
    }

    setTrackPickUpDateTimeArrOneWay((prevSelected) => {
      let date = elem[2] + " " + dailyPickupTime;
      let newSelected = [...prevSelected];

      if (newSelected.includes(date)) {
        // If the date is already in the array, remove it
        newSelected = newSelected.filter((d) => d !== date);
      } else {
        // If the date is not in the array, add it

        newSelected.push(date);
      }

      return newSelected;
    });

    setSendingDailyBookingDataOneWay((prevSelected) => {
      const newSelected = { ...prevSelected };

      if (newSelected.pickup_datetime.includes(date)) {
        // If the date is already in the array, remove it
        newSelected.pickup_datetime = newSelected.pickup_datetime.filter(
          (d) => d !== date
        );
      } else {
        // If the date is not in the array, add it
        newSelected.pickup_datetime.push(date);
      }

      return newSelected;
    });
  };

  return (
    <div className={packageStyle.packageWrapperDate}>
      {selectedDate &&
        PackageDayDate.length !== 0 &&
        PackageDayDate.map((elem, index) => (
          <div
            className={packageStyle.packageBoxDate}
            style={{
              backgroundColor: trackPickUpDateTimeArrOneWay.includes(
                elem[2] + " " + dailyPickupTime
              )
                ? "#E0F3EC"
                : "#ffffff",
            }}
            onClick={() => handleDailyTripDate(elem)}
            key={index}
          >
            <div
              className={packageStyle.miniCheck}
              style={{
                display: trackPickUpDateTimeArrOneWay.includes(
                  elem[2] + " " + dailyPickupTime
                )
                  ? ""
                  : "none",
              }}
            >
              <MiniCheck />
            </div>
            <div className={packageStyle.dateBookBox}>
              <div>{elem[0]}</div>
              <div>{elem[1].slice(0, 6)}</div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default DailyDate;
